import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Header, Button, Divider, Card, Loader } from 'semantic-ui-react'

import Firebase from 'firebase/app'

import RestaurantActions from '../../../../reducers/restaurantReducer'
import FreeCheckoutActions from '../../../../reducers/freeCheckoutReducer'

import FreeCheckoutCard from './Card'
import FreeCheckoutForm from './Form'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'auto',
  },
  headerWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0px 14px',
  }
}

class FreeCheckoutPromotions extends React.PureComponent {
  state = {
    formVisible: false,
    formData: null,
  }

  componentDidMount() {
    const { fetchRestaurants, restaurantLoaded, syncFreeCheckoutPromotions } = this.props

    if (!restaurantLoaded) fetchRestaurants()

    syncFreeCheckoutPromotions()
  }

  componentWillUnmount() {
    const { unSyncFreeCheckoutPromotions } = this.props

    unSyncFreeCheckoutPromotions()
  }

  onEdit = data => {
    this.setState({ formVisible: true, formData: data })
  }

  onDelete = key => {
    // eslint-disable-next-line no-alert
    const confirmation = window.confirm('Are you sure you want to delete this promotion?')

    if (confirmation) Firebase.firestore().collection('free_checkout_promotions').doc(key).delete()
  }

  renderFreeCheckouts = freeCheckouts => {
    if (_.size(freeCheckouts) === 0) return <Header textAlign='center' size="small" style={{ padding: 16 }}>No data available</Header>

    return (
      <Card.Group style={{ margin: 0 }}>
        {_.map(freeCheckouts, (freeCheckout, key) => (
          <FreeCheckoutCard
            key={key}
            freeCheckout={freeCheckout}
            onEdit={() => this.onEdit(freeCheckout)}
            onDelete={() => this.onDelete(key)}
          />
        ))}
      </Card.Group>
    )
  }

  render() {
    const { freeCheckouts, restaurants, restaurantLoaded, loading } = this.props
    const { formVisible, formData } = this.state

    if (loading || !restaurantLoaded) {
      return (
        <React.Fragment>
          <Loader active />
        </React.Fragment>
      )
    }

    return (
      <div style={styles.container}>
        <div style={styles.headerWrapper}>
          <Header style={{ marginBottom: 0 }}>
            {`Free Checkout Promotions (${_.size(freeCheckouts)})`}
          </Header>
          <Button
            icon="add"
            color="black"
            content="Add New"
            onClick={() => this.setState({ formVisible: true })}
          />
        </div>

        <Divider style={{ margin: 14 }} />

        <div style={{ overflow: 'auto' }}>{this.renderFreeCheckouts(freeCheckouts)}</div>

        {formVisible && (
          <FreeCheckoutForm
            freeCheckout={formData}
            merchants={Object.values(restaurants)}
            onClose={() => this.setState({ formData: null, formVisible: false })}
          />
        )}

      </div>
    )
  }
}

const mapState = ({ freeCheckouts, restaurants }) => ({
  restaurants: restaurants.data,
  restaurantLoaded: restaurants.loaded,

  loading: freeCheckouts.loading,
  freeCheckouts: freeCheckouts.data,
})

const mapDispatch = {
  fetchRestaurants: RestaurantActions.fetchRestaurantsRequest,

  syncFreeCheckoutPromotions: FreeCheckoutActions.syncFreeCheckoutPromotions,
  unSyncFreeCheckoutPromotions: FreeCheckoutActions.unSyncFreeCheckoutPromotions,
}

export default connect(
  mapState,
  mapDispatch
)(FreeCheckoutPromotions)



// WEBPACK FOOTER //
// ./src/containers/promotions/components/FreeCheckouts/index.js